import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import autoAnimate from '@marcreichel/alpine-auto-animate'
import Alpine from 'alpinejs'
import AsyncAlpine from 'async-alpine'

import registerAsyncComponents from '~/scripts/async-components'
import registerComponents from '~/scripts/components'

import { useLenis } from '~/scripts/composables/useLenis'
import registerDirectives from '~/scripts/directives'
import registerMagics from '~/scripts/magics'
import registerStoreModules from '~/scripts/store'
import { scrollToAnchor } from '~/scripts/utils/scroll'

export default function App() {
  useLenis({
    duration: 1.2,
    prevent: (element) => {
      if (element.id === '#wpadminbar')
        return true
      if (element.id === '#query-monitor-main')
        return true
      if (element.classList.contains('cky-modal'))
        return true
      if (element.role === 'dialog')
        return true
      if (element.tagName === 'DIALOG')
        return true
      return false
    },
  })

  window.Alpine = Alpine

  // Register plugins
  Alpine.plugin(AsyncAlpine)
  Alpine.plugin(autoAnimate)
  Alpine.plugin(collapse)
  Alpine.plugin(focus)
  Alpine.plugin(intersect)
  registerMagics()
  registerStoreModules()
  registerDirectives()
  registerComponents()
  registerAsyncComponents()

  // Make Alpine's store available globally
  let result = document.querySelector('[x-data]:not([x-load])')
  if (!result) {
    // No synchronous component found, let's make a little one
    result = document.createElement('div')
    result.setAttribute('x-data', '')
    document.body.appendChild(result)
  }
  document.addEventListener('alpine:initialized', async () => {
    if (result) {
      // @ts-expect-error Alpine's store will be available at this path so this is type-safe
      window.$store = result._x_dataStack[0].$store
    }
  })

  Alpine.start()

  // DataLayer events
  if (window.dataLayer) {
    for (const element of document.querySelectorAll<HTMLElement>(
      '[data-event]',
    )) {
      element.addEventListener('click', () => {
        const { event } = element.dataset
        if (event) {
          window.dataLayer?.push({ event })
        }
      })
    }
  }

  // Smooth scroll to anchors
  for (const anchor of document.querySelectorAll<HTMLAnchorElement>(
    'main a[href*="#"]:not([href$="#"])',
  )) {
    anchor.addEventListener('click', (event) => {
      scrollToAnchor(anchor, event, { blacklist: [] })
    })
  }
}
